import {
  Component, OnInit, Input, Output, EventEmitter, OnChanges
} from '@angular/core';
import { DmCustomFiltersInterface } from './dm-custom-filters-interface';
import { LayoutService } from 'src/app/layout/layout.service';
import { DataTableConfig } from '../../table/table-interface';
import { CommonServiceLayerService } from 'src/app/services/common-service-layer.service';
import { SharedService } from '../../shared.service';
import { SessionhandlerService } from '../../../services/sessionhandler.service';
import { AlertService } from 'src/app/shared/alert.service';
import { GlobalVariablesService } from 'src/app/layout/global-variables.service';
import { Config } from 'src/app/config/config';

@Component({
  selector: 'app-dm-custom-filters',
  templateUrl: './dm-custom-filters.component.html',
  styleUrls: ['./dm-custom-filters.component.scss']
})
export class DmCustomFiltersComponent implements OnInit {

  constructor(
    public modalService: LayoutService,
    public http: CommonServiceLayerService,
    public sharedService: SharedService,
    public alert: AlertService,
    public layoutService: LayoutService,
    public storage: SessionhandlerService,
    public globalVariables: GlobalVariablesService
  ) {
    this.modalAction = new EventEmitter<any>();
    this.selectFields = new EventEmitter<any>();
  }
  @Input() modalData: DmCustomFiltersInterface;
  @Output() modalAction: EventEmitter<any>;
  @Output() selectFields: EventEmitter<any>;
  @Input() siteId;
  public staticForm: any;
  public dateTimeRange = [new Date(), new Date()];
  public FieldList: any = [];
  public dayFilter: any;
  public InputJson: any;
  public dependentData: any = {};
  public paramList: any = [];
  public item: any = {
    checked: false
  };
  public siteName: any;
  public options: any = {
    required: true,
    selectMode: 'range',
    pickerType: 'both',
    disabled: false,
    columns: '12'
  };
  ngOnInit() {
    this.onLoadFunctions();
  }
  onLoadFunctions() {
    this.dateTimeRange[0].setDate(this.dateTimeRange[0].getDate() - 1);
    this.layoutService.getStaticFilterFields().subscribe(res => {
      this.setStaticForm(res);
    });
  }
  setStaticForm(res) {
    try {
      this.FieldList = [];
      const dateTimeFilters = this.globalVariables.FILTER_FORM_MAPPING.dateTimeFilters;
      this.staticForm = res;
      this.staticForm.forEach(element => {
        element.hidden = true;
      });
      this.modalData.staticFields.forEach(field => {
        this.staticForm.forEach(data => {
          if (field.dependency) {
            if (field.key === data.key) {
              if (data.key !== field.dependency) {
                data.type = field.type;
                data.dependency = field.dependency;
                this.FieldList.push(data);
                if (this.siteId) {
                  this.selectFields[data.key] = this.siteId;
                  this.loadDependentData(data, data.dependency, this.siteId);
                  this.item.checked = false;
                  this.selectedParam('all');
                  setTimeout(() => {
                    $('.parameter-btn').removeClass('btn-custom').addClass('btn-primary');
                    this.selectedData();
                  }, 1000);
                }
                // this.selectFields[data.key] = data.options[0].key;
              }
            }
          } else {
            if (field.key === data.key) {
              data.type = field.type;
              this.FieldList.push(data);
              if (this.siteId) {
                this.selectFields[data.key] = data.options[0].key;
              }
            }
          }
        });
        if (field.key === 'dateRange') {
          this.FieldList.push({ key: 'dateRange' });
        }
        if (field.key === 'dayFilter') {
          this.dayFilter = [{
            key: '1d', label: '1 Day'
          },
          {
            key: '7d', label: '7 Day'
          },
          {
            key: '30d', label: '30 Day'
          }]
        }
        if (field.key === 'monitoringTypes') {
          this.FieldList.push({ key: 'monitoringTypes' });
        }
        // if (field.key === 'monitoringTypes') {
        //   this.FieldList.push({ key: 'monitoringTypes' });
        // }
        console.log(this.FieldList)
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  loadDependentData(data, key, parentKey, onchange?) {
    if (onchange && this.item.checked) {
      this.item.checked = !this.item.checked;
    }
    this.deselectTimeRanges();
    const index = data.options.findIndex(ele => ele.key === parentKey);
    if (data.options[index]) {
      this.siteName = data.options[index].label;
    }
    if (data.dependencyKeys.indexOf(key)) {
      this.dependentData = data.dependentOptions[parentKey];
    }
  }
  selectedParam(data, event?) {
    const ID = data.label;
    if (data === 'all') {
      this.item.checked = !this.item.checked;
      if (!this.item.checked) {
        $('.parameter-btn').removeClass('btn-primary').addClass('btn-custom');
        this.paramList = [];
      } else {
        $('.parameter-btn').removeClass('btn-custom').addClass('btn-primary');
        this.dependentData.forEach(element => {
          this.paramList.push(element.key);
        });
      }
    } else {
      if ($('#' + ID).hasClass('btn-primary')) {
        $('#' + ID).removeClass('btn-primary').addClass('btn-custom');
        // this.paramList.remove(data.key);
        const index = this.paramList.indexOf(data.key);
        if (index !== -1) { this.paramList.splice(index, 1); }
      } else {
        $('#' + ID).removeClass('btn-custom').addClass('btn-primary');
        this.paramList.push(data.key);
      }
    }
  }
  inputData(timeInterval?) {
    this.selectFields['parameters'] = this.paramList;
    const button: any = {};
    if (this.selectFields['station'] && this.selectFields['parameters'].length > 0 && this.selectFields["averageInterval"]) {
      button.actionType = 'fetch';
      if (timeInterval) {
        this.selectFields['timeInterval'] = timeInterval;
      } else {
        this.selectFields['dateTimeRange'] = this.sharedService.formatFromAndToDates(this.dateTimeRange);
      }
      const payLoad = this.selectFields;
      payLoad['siteName'] = this.siteName;
      this.modalAction.emit({ button: button, payLoad });
    } else {
      this.alert.open('info', 'Please select at least one option in all the drop downs', 'Failed');
      this.deselectTimeRanges();
    }
  }
  selectedData() {
    if ($('.dayFilters').hasClass('btn-primary')) {
      $('.dayFilters').removeClass('btn-primary').addClass('btn-custom');
    }
    this.selectFields['timeInterval'] = '';
    this.inputData();
  }
  changeDayFilter(day) {
    if ($('.dayFilters').hasClass('btn-primary')) {
      $('.dayFilters').removeClass('btn-primary').addClass('btn-custom');
      $('#' + day.key).removeClass('btn-custom').addClass('btn-primary');
    } else {
      $('#' + day.key).removeClass('btn-custom').addClass('btn-primary');
    }
    // this.selectFields['day'] = day.key;
    this.selectFields['dateTimeRange'] = [];
    this.inputData(day.key);
  }
  deselectTimeRanges() {
    if ($('.dayFilters').hasClass('btn-primary')) {
      $('.dayFilters').removeClass('btn-primary').addClass('btn-custom');
    }
  }
}
